import styled from 'styled-components';
import base from '@sizeid/commons/utils/base';
import { media } from '@sizeid/commons/utils/styles';

export default styled.div`
  > div {
    margin-top: ${base(0.5)};
  }

  ${media.moreThan('smPlus')`
    display: flex;
    align-items: stretch;
    margin-left: -${base(0.5)};

    > div {
      flex: 0 1 33%;
      margin-left: ${base(0.5)};
    }
  `};
`;
